import { Autocomplete, Chip, TextField } from '@mui/material';

interface AutoCompleteSelectProps {
  options: any[];
  label: string;
  size?: number;
  multiline?: boolean;
  selectedValues: any;
  onChange: any;
  optionsValueKey: string;
  optionsLabelKey: string;
  disabled?: boolean;
  disableCloseOnSelect?: boolean;
  className?: string;
}

const AutoCompleteMultiSelect = ({
  options,
  label,
  size,
  multiline,
  selectedValues,
  onChange,
  optionsValueKey,
  optionsLabelKey,
  disabled,
  disableCloseOnSelect,
  className,
}: AutoCompleteSelectProps) => {
  const handleDelete = (valueToDelete: any) => {
    if (Array.isArray(selectedValues)) {
      const updatedValues = selectedValues.filter((value) => value[optionsValueKey] !== valueToDelete[optionsValueKey]);
      onChange(updatedValues);
    } else {
      onChange(null);
    }
  };

  const handleChange = (_e: any, values: any) => {
    onChange(values);
  };

  return (
    <Autocomplete
      multiple
      size="small"
      id="multi-select"
      options={options}
      value={selectedValues ?? []}
      onChange={handleChange}
      disableCloseOnSelect
      disabled={disabled}
      getOptionKey={(option) => option[optionsValueKey]}
      getOptionLabel={(option) => option[optionsLabelKey]}
      renderTags={(value, getTagProps) => {
        if (Array.isArray(value)) {
          return value.map((option, index) => {
            const currentOption = options?.find((o) => o[optionsValueKey] === option[optionsValueKey]);
            if (currentOption) {
              return (
                <Chip
                  {...getTagProps({ index })}
                  key={currentOption[optionsValueKey]}
                  label={currentOption[optionsLabelKey]}
                  onDelete={() => handleDelete(currentOption)}
                  size="small"
                />
              );
            }
          });
        } else {
          const currentOption = options?.find((o) => o[optionsValueKey] === value[optionsValueKey]);
          return (
            <Chip
              {...getTagProps}
              key={currentOption[optionsValueKey]}
              label={currentOption[optionsLabelKey]}
              size="small"
            />
          );
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" multiline={multiline} rows={size ? size : 4} />
      )}
      isOptionEqualToValue={(option, value) => option[optionsValueKey] === value[optionsValueKey]}
    />
  );
};

export default AutoCompleteMultiSelect;
